import { useState } from "react";
import { useFetch } from "@chainless/chainless-react";
import "../index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MeldingCharts } from "../components/MeldingCharts";
import { ImagePopup } from "../components/ImagePopup";
import { UpdateMelding } from "../components/UpdateMelding";
import { TextPopup } from "../components/TextPopup";
import { InputText } from "primereact/inputtext";

export const MeldingVoorvalPage = () => {
  const {
    data: meldingen,
    error,
    loading,
    fetchData,
  } = useFetch("/api/meldingen");
  const [expandedRows, setExpandedRows] = useState();
  const [projectFilter, setProjectFilter] = useState("");

  const refreshData = () => {
    fetchData();
  };

  const [sortField, setSortField] = useState("timestamp");
  const [sortOrder, setSortOrder] = useState(-1);

  const sortedMeldingen =
    meldingen && Array.isArray(meldingen)
      ? [...meldingen].sort((a, b) => {
        const aVal = a[sortField] || 0;
        const bVal = b[sortField] || 0;
        if (aVal < bVal) return -1 * sortOrder;
        if (aVal > bVal) return 1 * sortOrder;
        return 0;
      })
      : [];

  const filteredMeldingen = projectFilter
    ? sortedMeldingen.filter((m) =>
      (m.project || "").toLowerCase().includes(projectFilter.toLowerCase())
    )
    : sortedMeldingen;

  return (
    <>
      {loading && <p>Meldingen ophalen...</p>}
      {error && <p>Error bij ophalen meldingen: {error}</p>}
      {meldingen && meldingen.length > 0 && (
        <>
          <div className="inhoud">
            <div className="tabel">
              <h1>Alle meldingen</h1>
              <div className="table">
                <div style={{ marginBottom: 10, textAlign: "right" }}>
                  <InputText
                    type="text"
                    placeholder="Zoek op project..."
                    value={projectFilter}
                    onChange={(e) => setProjectFilter(e.target.value)}
                    style={{ padding: "4px 8px", minWidth: 180 }}
                  />
                </div>
                <DataTable
                  value={filteredMeldingen}
                  stripedRows
                  showGridlines
                  paginator={true}
                  pageLinkSize={3}
                  rows={10}
                  rowExpansionTemplate={(rowData) => (
                    <UpdateMelding rowData={rowData} refresh={refreshData} />
                  )}
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  sortField={sortField}
                  sortOrder={sortOrder}
                  onSort={(e) => {
                    setSortField(e.sortField);
                    setSortOrder(e.sortOrder);
                  }}
                >
                  <Column expander style={{ minWidth: "3em" }} />
                  <Column
                    className="table-column"
                    field="timestamp"
                    header="Datum melding"
                    sortable
                    sortField="timestamp"
                    body={(rowData) =>
                      new Date(rowData.timestamp * 1000).toLocaleDateString(
                        "nl-NL"
                      )
                    }
                  />
                  <Column
                    style={{ minWidth: "3em" }}
                    field="prioriteit"
                    header="Prio"
                    body={(rowData) => {
                      if (!rowData.prioriteit) return "";
                      const match = rowData.prioriteit.match(/PRIO_(\d)/);
                      return match ? match[1] : rowData.prioriteit;
                    }}
                  />
                  <Column
                    className="table-column"
                    field="beschrijving"
                    header="Beschrijving"
                    body={(rowData) => (
                      <TextPopup
                        text={rowData.beschrijving}
                        headerText={"Beschrijving"}
                      />
                    )}
                  />
                  <Column
                    className="table-column"
                    field="project"
                    header="Project"
                    body={(rowData) => (
                      <TextPopup
                        text={rowData.project}
                        headerText={"Project"}
                      />
                    )}
                  />
                  <Column
                    className="table-column"
                    field="projectLeider"
                    header="Projectleider"
                  />
                  <Column
                    className="table-column"
                    field="locatie"
                    header="Locatie"
                    body={(rowData) => (
                      <TextPopup
                        text={rowData.locatie}
                        headerText={"Locatie"}
                      />
                    )}
                  />
                  <Column
                    field="melder"
                    header="Melder"
                    body={(rowData) => (
                      <TextPopup text={rowData.melder} headerText={"Melder"} />
                    )}
                  />
                  <Column
                    style={{ minWidth: "3em" }}
                    field="werkVoortzetting"
                    header="Werk voortzetting"
                    body={(rowData) =>
                      rowData.werkVoortzetting === true
                        ? "Ja"
                        : rowData.werkVoortzetting === false
                          ? "Nee"
                          : ""
                    }
                  />
                  <Column
                    className="table-column"
                    field="foto's"
                    header="Foto's"
                    body={(rowData) => (
                      <>
                        {rowData.foto &&
                          rowData.foto.map((foto) => (
                            <ImagePopup
                              key={foto}
                              src={foto !== "" ? `/api/images/${foto}` : null}
                            />
                          ))}
                      </>
                    )}
                  />
                </DataTable>
              </div>
            </div>
          </div>
          <div className="grafieken">
            <MeldingCharts data={meldingen} />
          </div>
        </>
      )}
    </>
  );
};
